/**
 * Функция следит за удалением/добавлением в DOM потомков родительского элемента, и вызывает функции из массива
 * коллбэков. Если родитель не найден по селектору, то ничего не происходит, ошибка выбрасываться не должна.
 * @param {object} options -
 * @param {string} options.selectorParent - селектор контейнера, на который навешивается наблюдатель
 * @param {Function[]} options.callbacks - массив функций коллбэков
 * @param {object} options.config - объект конфигурации MutationObserver, по умолчанию "{childList: true}"
 */
function observeDOM({ selectorParent, callbacks = [], config = { childList: true } }) {
  const targetNode = document.querySelector(selectorParent)

  if (!targetNode) {
    return
  }

  if (!callbacks.length) {
    return
  }

  const callback = () => {
    callbacks.forEach(fn => setTimeout(fn))
  }

  const observer = new MutationObserver(callback)

  observer.observe(targetNode, config)
}

export default observeDOM
